import { Global } from '@emotion/react';
import { DesignSystemGlobalVariables } from '../shared/designSystem/constants';

export default function GlobalVariables() {
  return <Global styles={[DesignSystemGlobalVariables]} />;
}
